import { styled } from 'linaria/react';
import { media } from '../../../media';

export const Container = styled.div`
	position: relative;
	width: 100%;
	max-width: 1366px;
	padding: 0 93px;
	margin: 0 auto;

	${media.laptop} {
		padding: 0 42px;
	}

	${media.tablet} {
		padding: 0 54px;
	}

	${media.mobile} {
		padding: 0 16px;
	}
`;
